<template>
  <!-- ======= Footer ======= -->
  <footer id="footer" class="footer">
    <div class="footer-content">
      <div class="container">
        <div class="row gy-4">
          <div class="col-lg-5 col-md-12 footer-info">
            <a
              href="/#"
              class="logo d-flex align-items-center"
              style="
                text-decoration: underline 2px var(--color-primary) !important;
              "
            >
              <!-- <span>{{ $t("title") }}</span> -->
              <div class="row">
                <div class="col-lg-6 col-12">
                  <img src="assets/img/logo.png" alt="" />
                </div>
                <div class="col-lg-6 col-12">
                  <img src="assets/img/2030-vision.png" alt="vision2030" />
                </div>
              </div>
            </a>
            <p>
              {{
                $i18n.locale === "ar"
                  ? $store.state.welcome_message_ar
                  : $store.state.welcome_message_en
              }}
            </p>
            <div class="social-links d-flex mt-3">
              <a
                v-if="$store.state.twitter"
                :href="$store.state.twitter"
                target="_blank"
                class="twitter"
                ><i class="bi bi-twitter"></i
              ></a>
              <a
                v-if="$store.state.facebook"
                :href="$store.state.facebook"
                class="facebook"
                ><i class="bi bi-facebook"></i
              ></a>
              <a
                v-if="$store.state.instagram"
                :href="$store.state.instagram"
                target="_blank"
                class="instagram"
                ><i class="bi bi-instagram"></i
              ></a>
              <a
                v-if="$store.state.linkdin"
                :href="$store.state.linkdin"
                class="linkedin"
                target="_blank"
                ><i class="bi bi-linkedin"></i
              ></a>
              <a
                v-if="$store.state.phone"
                :href="`https://wa.me/${$store.state.phone}`"
                class="whatsapp"
                target="_blank"
                ><i class="bi bi-whatsapp"></i
              ></a>
            </div>
          </div>

          <div class="col-lg-2 col-6 footer-links">
            <h4>{{ $t("UsefulLinks") }}</h4>
            <ul>
              <li>
                <i class="bi bi-dash"></i>
                <a href="/#" class="active">{{ $t("home") }}</a>
              </li>
              <li>
                <i class="bi bi-dash"></i>
                <a href="/#about">{{ $t("about") }}</a>
              </li>
              <li>
                <i class="bi bi-dash"></i>
                <a href="/#vision">{{ $t("vision.title") }}</a>
              </li>
              <li>
                <i class="bi bi-dash"></i>
                <a href="/#services">{{ $t("servicestitle") }}</a>
              </li>
              <li>
                <i class="bi bi-dash"></i>
                <a href="/#contact">{{ $t("contact") }}</a>
              </li>
              <li>
                <i class="bi bi-dash"></i>
                <a href="/privacy-policy">{{ $t("privacy.title") }}</a>
              </li>
            </ul>
          </div>

          <div class="col-lg-2 col-6 footer-links">
            <h4>{{ $t("servicestitle") }}</h4>
            <ul>
              <li v-for="(item, index) in $store.state.products" :key="index">
                <i class="bi bi-dash"></i>
                <a
                  :href="
                    item.link === null ||
                    item.link === 'NULL' ||
                    item.link === ''
                      ? '/service?id=' + item.id
                      : item.link
                  "
                >
                  {{ $i18n.locale == "ar" ? item.name_ar : item.name_en }}
                </a>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-12 footer-contact">
            <h4>{{ $t("contact") }}</h4>
            <p>
              {{
                $i18n.locale === "ar"
                  ? $store.state.loaction_name_ar
                  : $store.state.loaction_name_en
              }}<br /><br />
              <!-- <strong>Phone:</strong> +1 5589 55488 55<br /> -->
              <strong>{{ $t("email") }}:</strong> {{ $store.state.email }}<br />
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-legal">
      <div class="container">
        <div class="copyright">
          &copy; Copyright
          <strong><span>Nexus Leap</span></strong
          >. All Rights Reserved
        </div>
        <!-- <div class="credits">Designed by <a href="">TechMasters</a></div> -->
      </div>
    </div>
  </footer>
  <!-- End Footer -->
</template>
